export default "<video #target class=\"video-js\" controls playsinline preload=\"none\"></video>\n";